import { ApiConditionCustom, ApiOperator, ApiEngagementPayload, ApiConditionGroup, ApiEngagementRule } from "@incendium/api";
import { engagementService } from "Apis";
import { isEmpty } from "lodash";

const engagementToPayload = (engagement: ApiEngagementRule): ApiEngagementPayload => {
  return {
    name: engagement.name,
    score: engagement.score,
    maxScore: engagement.maxScore,
    locations: engagement.locations,
    conditionGroups: (engagement.conditionGroups as ApiConditionGroup[])
      .filter((c) => {
        return (
          !isEmpty(c) &&
          (c.conditions || []).filter((co) => !isEmpty(co)).length > 0
        );
      })
      .map((c) => ({
        conditions: (c.conditions || []).map((condition) => {
          if (
            condition.custom !== ApiConditionCustom.CONVERSION_TRIGGERED
          ) {
            return {
              ...condition,
              operator: ApiOperator.IS_GREATER_THAN_OR_EQUAL,
            };
          }

          return {
            ...condition,
            operator: ApiOperator.EQUAL,
          };
        }),
      })),
  }
};

export const saveLeadScoreEngagementRule = async (projectId: number, engagement: ApiEngagementRule) => {
  const fn = engagement.id ? engagementService.engagementServiceUpdateEngagement({
    projectId,
    engagementId: engagement.id as number,
    payload: engagementToPayload(engagement),
  }) : engagementService.engagementServiceCreateEngagement({
    projectId,
    payload: engagementToPayload(engagement),
  });
  const res = await fn;
  return res;
};